import { useAppSelector } from 'hooks/reduxHooks'
import { buildParamsKey } from 'lib/offer/availabilityUtils'

function useOfferAvailableRates(
  offerId?: string,
  params?: {
    checkIn?: string;
    checkOut?: string;
    rooms?: Array<App.Occupants>;
  },
): App.OfferAvailableRates | undefined {
  const offerAvailableRates = useAppSelector(state => offerId ? state.offer.offerAvailableRates[offerId] : {}) ?? {}
  const offerAvailableRatesKey = params && params.checkIn && params.checkOut && params.rooms ? buildParamsKey(params.checkIn, params.checkOut, params.rooms) : undefined

  return offerAvailableRatesKey ? offerAvailableRates[offerAvailableRatesKey] : undefined
}

export function useOffersAvailableRates(
  offersIds: string[],
  params?: {
    checkIn?: string;
    checkOut?: string;
    rooms?: Array<App.Occupants>;
  },
): { [offerId: string]: App.OfferAvailableRates } {
  const offersAvailableRates = useAppSelector(state => offersIds.map(offerId => state.offer.offerAvailableRates?.[offerId])) ?? {}
  const offerAvailableRatesKey = params && params.checkIn && params.checkOut && params.rooms ? buildParamsKey(params.checkIn, params.checkOut, params.rooms) : undefined

  return offersIds.reduce((acc, offerId, index) => {
    acc[offerId] = offerAvailableRatesKey ? offersAvailableRates[index]?.[offerAvailableRatesKey] : undefined
    return acc
  }, {})
}

export default useOfferAvailableRates
